/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty, isLoaded} from 'react-redux-firebase'

import {Block} from 'baseui/block'

import {assets} from '../../utils/config'
import {Helmet, Toaster} from '../app'

import {Footer} from '../app'

// noinspection HtmlRequiredTitleElement
const MainLayout = ({children}) => {
  const auth = useSelector(state => state.firebase.auth)
  const night = !isLoaded(auth) || isEmpty(auth)

  return (
    <>
      <Helmet title="Secret of the Source Code" />
      <Block
        overrides={{
          Block: {
            style: ({$theme}) => ({
              // backgroundImage: 'linear-gradient(#eed88c, #faab38)',
              backgroundImage: night
                ? 'linear-gradient(#10b4b0, #662d91)'
                : 'linear-gradient(#ff9400, #ffd855)',
              display: 'flex',
              position: 'relative',
              width: 100 + '%',
              height: 100 + '%',
            }),
          },
        }}
      >
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                content: '""',
                display: 'block',
                width: 100 + '%',
                height: 100 + '%',
                backgroundImage: `url("${assets.auth.clouds}") repeat-x 50% 100%`,
                backgroundSize: 1600 + 'px',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
                backgroundPositionY: 'top',
                position: 'absolute',
                pointerEvents: 'none',
                top: 0,
                left: 0,
              }),
            },
          }}
        />
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                content: '""',
                display: 'block',
                width: 100 + '%',
                height: 100 + '%',
                backgroundImage: `url("${
                  night ? assets.bkg.night.landscape : assets.bkg.day.landscape
                }")`,
                backgroundSize: 1920 + 'px',
                backgroundRepeat: 'repeat-x',
                backgroundPositionX: 'center',
                backgroundPositionY: 'bottom',
                position: 'absolute',
                pointerEvents: 'none',
                top: 0,
                left: 0,
                [$theme.media.medium]: {
                  backgroundSize: 1920 + 'px',
                },
              }),
            },
          }}
        />
        <Block
          overrides={{
            Block: {
              style: {
                position: 'relative',
                width: '100%',
                height: '100%',
                overflowY: 'auto',
              },
            },
          }}
        >
          {children}
        </Block>
      </Block>
      <Block
        overrides={{
          Block: {
            style: {
              position: 'absolute',
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              gap: '5rem',
              width: '100%',
              height: '10%',
              marginBottom: '4rem',
              overflowY: 'visible',
              overflowX: 'visible',
            },
          },
        }}
      >
        <Block
          $as="img"
          src={assets.sponsors.can}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                width: 'auto',
                height: 'auto',
                // [$theme.media.small]: {
                //   height: '10rem',
                // },
                // [$theme.media.medium]: {
                //   height: '12rem',
                // },
              }),
            },
          }}
        />
        <Block
          $as="img"
          src={assets.sponsors.cmf}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                width: 'auto',
                height: 'auto',
                // [$theme.media.small]: {
                //   height: '10rem',
                // },
                // [$theme.media.medium]: {
                //   height: '12rem',
                // },
              }),
            },
          }}
        />
        <Block
          $as="img"
          src={assets.sponsors.oc}
          overrides={{
            Block: {
              style: ({$theme}) => ({
                width: 'auto',
                height: 'auto',
                // [$theme.media.small]: {
                //   height: '10rem',
                // },
                // [$theme.media.medium]: {
                //   height: '12rem',
                // },
              }),
            },
          }}
        />
      </Block>
      <Footer alignCopyright="right" night={night} />
      <Toaster />
    </>
  )
}

export default MainLayout
